// Turn-length rules shared by the server and the tournament editor.

export const MIN_TURN_SECONDS = 30;
export const MAX_TURN_SECONDS = 7 * 86400;

/**
 * Turns shorter than this are played live: no e-mails about turns. Device notifications are still
 * sent, but only when the player does not have the tournament open.
 */
export const EMAIL_MIN_TURN_SECONDS = 60;

/** The last seconds of your own turn tick audibly. */
export const TICK_SECONDS = 10;

/**
 * Reminders before the deadline (minutes), derived from the turn length: one when a quarter of the
 * time is left, and for turns of two hours or more another at 1/24 (12 h → 3 h and 30 min before).
 * Turns under four minutes have none: the clock and its ticking are reminder enough.
 */
export function reminderMinutes(turnSeconds: number): number[] {
  const minutes = turnSeconds / 60;
  if (minutes < 4) return [];
  const list = [Math.round(minutes / 4)];
  if (minutes >= 120) list.push(Math.round(minutes / 24));
  return [...new Set(list)].sort((a, b) => b - a);
}
